import axios, { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

export const getPortfolioForCustomer = (instance: AxiosInstance) => async (customerId: string): Promise<Portfolio[]> => {
  const { data } = await instance.get<Portfolio[]>(`/customers/${customerId}/portfolios`);

  return data;
};

export const getSinglePortfolioForCustomer = (instance: AxiosInstance) => async (customerId: string, portfolioId: string): Promise<Portfolio> => {
  const { data } = await instance.get<Portfolio>(`/customers/${customerId}/portfolios/${portfolioId}`);

  return data;
};

export const getPortfolioForPartnership = (instance: AxiosInstance) => async (partnershipId: string, currency: string): Promise<Portfolio[]> => {
  const { data } = await instance.get<Portfolio[]>(`/partnerships/${partnershipId}/portfolios?currency=${currency}`);

  return data;
};
export const getSinglePortfolioForPartnership = (instance: AxiosInstance) => async (
  partnershipId: string,
  portfolioId: string,
): Promise<Portfolio> => {
  const { data } = await instance.get<Portfolio>(`/partnerships/${partnershipId}/portfolios/${portfolioId}`);

  return data;
};

export const getAllPortfolios = (instance: AxiosInstance) => async (): Promise<Portfolio[]> => {
  const { data } = await instance.get<Portfolio[]>('/portfolios');

  return data;
};

export const getAllProjects = (instance: AxiosInstance) => async (): Promise<BasicProject[]> => {
  const { data } = await instance.get<BasicProject[]>('/projects');

  return data;
};

export const switchPortfolioForCustomer = (instance: AxiosInstance) => async (customerId: string, sanityPortfolioId: string): Promise<void> => {
  await instance.put(`/customers/${customerId}/portfolios`, { sanityPortfolioId });
};

export const switchPortfolioForPartnership = (instance: AxiosInstance) => async (partnershipId: string, sanityPortfolioId: string): Promise<void> => {
  await instance.put(`/partnerships/${partnershipId}/portfolios`, { sanityPortfolioId });
};

export const downloadFromUrl = async (url: string): Promise<Blob> => {
  const { data } = await axios.get<Blob>(url, {
    responseType: 'blob',
  });

  return data;
};

const handlers = {
  getPortfolioForCustomer,
  getPortfolioForPartnership,
  getSinglePortfolioForCustomer,
  getSinglePortfolioForPartnership,
  getAllPortfolios,
  getAllProjects,
  switchPortfolioForCustomer,
  switchPortfolioForPartnership,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createProjectApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createProjectApi;
